import React from 'react'
import { Box, IconButton, Paper, Tooltip, Typography } from '@material-ui/core'
import clsx from 'clsx'
import { LocalParkingRounded, DirectionsBusRounded } from '@material-ui/icons'
import parkingButtonPanelStyles from './parkingButtonPanelStyles'
import { CustomIcon } from '../../../../../apps/AppComponents/IconPicker/IconPicker'

export default function ParkingButtonPanel({
  updateShowParkingLots,
  updateShowMissingParkingLots,
  showParkingLots,
  showMissingParkingLots,
  showBusStops,
  updateShowBusStops,
  isMobileWithoutBottomNav,
}) {
  const classes = parkingButtonPanelStyles()
  return (
    <Box
      component={Paper}
      className={
        isMobileWithoutBottomNav
          ? classes.parkingButtonPanelContainerMobile
          : classes.parkingButtonPanelContainer
      }
    >
      {window.location.hostname === 'localhost' ? (
        <Tooltip
          placement="right"
          title={
            <Typography variant="subtitle2">
              {showMissingParkingLots
                ? 'Hide Missing Lots (dev only)'
                : 'Show Missing Lots (dev only)'}
            </Typography>
          }
          arrow
        >
          <IconButton
            className={
              showMissingParkingLots
                ? classes.enabledButton
                : classes.disabledButton
            }
            onClick={() => {
              updateShowMissingParkingLots((state) => !state)
            }}
          >
            <CustomIcon
              imgSrc="./assets/images/svgs/parking-lot-icon.svg"
              size={33}
            />
          </IconButton>
        </Tooltip>
      ) : null}
      <Tooltip
        placement="right"
        title={
          <Typography variant="subtitle2">
            {showBusStops ? 'Hide Bus Stops' : 'Show Bus Stops'}
          </Typography>
        }
        arrow
      >
        <IconButton
          aria-label={showBusStops ? 'Hide Bus Stops' : 'Show Bus Stops'}
          className={
            showBusStops
              ? clsx(classes.enabledButton, classes.busStopsButton)
              : clsx(classes.disabledButton, classes.busStopsButton)
          }
          onClick={() => {
            updateShowBusStops((state) => !state)
          }}
        >
          <DirectionsBusRounded htmlColor="#fff" fontSize="large" />
        </IconButton>
      </Tooltip>
      <Tooltip
        placement="right"
        title={
          <Typography variant="subtitle2">
            {showParkingLots ? 'Hide Parking Lots' : 'Show Parking Lots'}
          </Typography>
        }
        arrow
      >
        <IconButton
          aria-label={
            showParkingLots ? 'Hide Parking Lots' : 'Show Parking Lots'
          }
          className={
            showParkingLots ? classes.enabledButton : classes.disabledButton
          }
          onClick={() => {
            updateShowParkingLots((state) => !state)
          }}
        >
          <LocalParkingRounded htmlColor="#fff" fontSize="large" />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
